/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import { Send, Bot, User, Sparkles, ChevronDown } from 'lucide-react';
import ReactMarkdown from 'react-markdown';

function Assistant() {
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const messagesEndRef = useRef(null);
    const ws = useRef(null);
    const currentMessageRef = useRef('');

    const connectWebSocket = () => {
        ws.current = new WebSocket(`${process.env.REACT_APP_KALA_IA_API_URL}/init`);

        ws.current.onopen = () => {
            console.log('WebSocket connected');
        };

        ws.current.onclose = () => {
            console.log('WebSocket closed');
            setTimeout(connectWebSocket, 1000);
        };

        ws.current.onerror = (error) => {
            console.error('WebSocket error:', error);
        };

        ws.current.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);

                if (data.action === 'init_system_response') {
                    setIsLoading(true);
                    currentMessageRef.current = '';
                    setMessages(prev => [...prev, { role: 'assistant', content: '', id: data.id }]);
                } else if (data.action === 'append_system_response') {
                    currentMessageRef.current += data.content;
                    setMessages(prev => {
                        const newMessages = [...prev];
                        const lastMessage = newMessages[newMessages.length - 1];
                        if (lastMessage.role === 'assistant') {
                            lastMessage.content = currentMessageRef.current;
                        }
                        return newMessages;
                    });
                } else if (data.action === 'finish_system_response') {
                    // currentMessageRef.current = '';
                    setIsLoading(false);
                }
            } catch (error) {
                console.error('Error processing message:', error);
            }
        };
    };

    useEffect(() => {
        connectWebSocket();

        return () => {
            if (ws.current) {
                ws.current.close();
                setIsLoading(false);
            }
        };
    }, []);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!input.trim() || isLoading) return;

        const userMessage = { role: 'user', content: input };
        setMessages(prev => [...prev, userMessage]);
        setInput('');

        if (ws.current?.readyState === WebSocket.OPEN) {
            const filteredMessages = messages.concat(userMessage).filter(msg => msg.role === 'user');
            ws.current.send(JSON.stringify(filteredMessages));
        } else {
            setMessages(prev => [...prev, {
                role: 'assistant',
                content: 'Disculpa, perdí la conexión, inténtalo más tarde.'
            }]);
        }
    };

    const handleNewChat = () => {
        setMessages([]);
        setInput('');
        currentMessageRef.current = '';
        if (ws.current) {
            ws.current.close();
        }
        setTimeout(() => {
            connectWebSocket();
        }, 500);
    };

    
    return (
        <div className="flex flex-col h-screen bg-[#0a0a0a]">
            {/* Header */}
            <div className="flex-none bg-[#111111] border-b border-[#2a2a2a]">
                <div className="max-w-5xl mx-auto px-4 py-4 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="bg-gradient-to-r from-blue-500 to-purple-500 p-2 rounded-lg">
                            <Bot className="w-6 h-6 text-white" />
                        </div>
                        <h1 className="text-xl font-semibold text-white">KALA IA</h1>
                    </div>
                    <button
                        onClick={handleNewChat}
                        className="flex items-center gap-2 px-4 py-2 text-[#888] hover:text-white transition-colors"
                    >
                        <Sparkles className="w-4 h-4" />
                        <span>Nuevo Chat</span>
                    </button>
                </div>
            </div>

            {/* Messages */}
            <div className="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-[#333] scrollbar-track-transparent">
                <div className="max-w-5xl mx-auto">
                    {messages.length === 0 && !isLoading && (
                        <div className="flex flex-col items-center justify-center h-full text-center px-4 py-20">
                            <div className="bg-gradient-to-r from-blue-500 to-purple-500 p-4 rounded-2xl mb-6">
                                <Bot className="w-12 h-12 text-white" />
                            </div>
                            <h2 className="text-2xl font-bold text-white mb-2">¡Hola, soy Kala IA!</h2>
                            <p className="text-[#888] max-w-md">Soy tu asistente y estoy aquí para ayudarte.</p>
                            <ChevronDown className="w-6 h-6 text-[#888] mt-8 animate-bounce" />
                        </div>
                    )}

                    <div className="space-y-6 px-4 py-6">
                        {messages.map((message, index) => (
                            <div
                                key={index}
                                className={`flex items-start gap-4 ${message.role === 'user' ? 'justify-end' : 'justify-start'}`}
                            >
                                {message.role === 'assistant' && (
                                    <div className="flex-none">
                                        <div className="bg-gradient-to-r from-blue-500 to-purple-500 p-2 rounded-lg">
                                            <Bot className="w-6 h-6 text-white" />
                                        </div>
                                    </div>
                                )}
                                <div
                                    className={`rounded-2xl px-6 py-4 max-w-[80%] ${message.role === 'user'
                                        ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white'
                                        : 'bg-[#1a1a1a] text-white border border-[#333]'}`}
                                >
                                    {message.role === 'assistant' ? (
                                        <div className="whitespace-pre-wrap leading-relaxed prose prose-invert max-w-none  [&>*:last-child]:mb-0">
                                            <ReactMarkdown
                                                components={{
                                                    p: ({node, ...props}) => <p className=" last:mb-0" {...props} />,
                                                    code: ({node, inline, ...props}) => 
                                                        inline ? (
                                                            <code className="bg-[#2a2a2a] rounded px-1" {...props} />
                                                        ) : (
                                                            <code className="block bg-[#2a2a2a] rounded p-4 my-2" {...props} />
                                                        ),
                                                        pre: ({node, ...props}) => <pre className="bg-transparent p-0 m-0" {...props} />,
                                                        ul: ({node, ...props}) => <ul className="list-disc pl-4 mb-0" {...props} />,
                                                        ol: ({node, ...props}) => <ol className="list-decimal pl-4 mb-0" {...props} />,
                                                        li: ({node, ...props}) => <li className="mb-0" {...props} />,
                                                        h1: ({node, ...props}) => <h1 className="text-2xl font-bold " {...props} />,
                                                        h2: ({node, ...props}) => <h2 className="text-xl font-bold " {...props} />,
                                                        h3: ({node, ...props}) => <h3 className="text-lg font-bold" {...props} />,
                                                        a: ({node, ...props}) => <a className="text-blue-400 hover:underline" {...props} />
                                                }}
                                            >
                                                {message.content}
                                            </ReactMarkdown>
                                        </div>
                                    ) : (
                                        <p className="whitespace-pre-wrap leading-relaxed">{message.content}</p>
                                    )}
                                </div>
                                {message.role === 'user' && (
                                    <div className="flex-none">
                                        <div className="bg-gradient-to-r from-purple-500 to-pink-500 p-2 rounded-lg">
                                            <User className="w-6 h-6 text-white" />
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}

                        {isLoading && (
                            <div className="flex items-center gap-3 text-[#888] px-4">
                                <div className="flex space-x-1">
                                    <div className="w-2 h-2 bg-blue-400 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
                                    <div className="w-2 h-2 bg-purple-400 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
                                    <div className="w-2 h-2 bg-pink-400 rounded-full animate-bounce"></div>
                                </div>
                                <span>...</span>
                            </div>
                        )}
                        <div ref={messagesEndRef} />
                    </div>
                </div>
            </div>

            {/* Input */}
            <div className="flex-none bg-[#111111] border-t border-[#2a2a2a] p-4">
                <div className="max-w-5xl mx-auto">
                    <form onSubmit={handleSubmit} className="flex gap-4">
                        <input
                            type="text"
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            placeholder="Hablemos de algo interesante..."
                            className="flex-1 bg-[#1a1a1a] text-white rounded-xl border border-[#333] px-6 py-4 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-[#666]"
                            disabled={isLoading}
                        />
                        <button
                            type="submit"
                            disabled={isLoading || !input.trim()}
                            className="bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-xl px-6 py-4 hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-[#111111] disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 transition-all"
                        >
                            <Send className="w-5 h-5" />
                            <span>Enviar</span>
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Assistant;